import React, { useState, useEffect } from "react";
import "./Services.css";

// Import your service images
import lockingWheelImg from '../assets/ds.webp';
import emergencyRepairImg from '../assets/pc.webp';
import partWornImg from '../assets/Ecu.webp';
import premium from '../assets/DEA.webp';
import AllSeason from "../assets/kcs.webp";
import carServiceImg from "../assets/DEA.webp";
import recoveryImg from "../assets/About-bg.webp";

function Services() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [hoveredService, setHoveredService] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
   const [isPaused, setIsPaused] = useState(false);

  const services = [
    {
      id: 1,
      number: "01",
      title: "ECU Remapping",
      description: "Advanced ECU remapping and tuning services to unlock your vehicle's full potential. Expert diagnostics, performance optimization, and emission solutions.",
      image: partWornImg,
      link: "/ecu-remapping"
    },
    {
      id: 2,
      number: "02", 
      title: "Programming & Coding",
      description: "Professional vehicle software programming and coding solutions for all major automotive brands. Module programming, feature activation, and system configuration.",
      image: emergencyRepairImg,
      link: "/programming"
    },
    {
      id: 3,
      number: "03",
      title: "Diagnostic Services", 
      description: "Comprehensive vehicle diagnostic and troubleshooting services. Advanced scanning, fault detection, and detailed system analysis for all vehicle systems.",
      image: lockingWheelImg,
      link: "/diagnostic"
    },
    {
      id: 4,
      number: "04",
      title: "Car Service",
      description: "Comprehensive car servicing packages from basic maintenance to full service. Professional checks, fluid changes, brake inspection, and advanced diagnostics.",
      image: carServiceImg,
      link: "/car-service"
    },
      {
      id: 5,
      number: "05",
      title: "Recovery Services",
      description: "Professional vehicle recovery and roadside assistance services. 24/7 emergency support, breakdown recovery, and transportation solutions.",
      image: recoveryImg,
      link: "/recovery"
    }
       //   {
    //   id: 5,
    //   number: "05",
    //   title: "Key Cutting & Solutions",
    //   description: "Complete automotive locksmith services including key cutting, programming, and emergency lockout assistance. Expert solutions for all vehicle key systems.",
    //   image: AllSeason,
    //   link: "/key-solutions"
    // },
  ];

  // Auto-scroll functionality
  useEffect(() => {
    if (isPaused) return; // Stop scrolling if paused

    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % services.length);
        setIsTransitioning(false);
      }, 800); // Match the CSS transition duration
    }, 5000);

    return () => clearInterval(interval);
  }, [services.length]);

  const goToSlide = (index) => {
    if (index === currentSlide || isTransitioning) return;
    
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide(index);
      setIsTransitioning(false);
    }, 800);
  };

  return (
    <section className="services-section">
      <div className="services-header">
        <h2>Our Services</h2>
        <p className="services-quote">"Professional automotive solutions, expert forensic analysis"</p>
      </div>
      
      <div className="services-slider-container">
        <div className="services-slider">
          {services.map((service, index) => (
            <div 
              key={service.id}
              className={`service-slide ${index === currentSlide ? 'active' : ''} ${index < currentSlide ? 'prev' : ''} ${index > currentSlide ? 'next' : ''}`}
              style={{ backgroundImage: `url(${service.image})` }}
              onMouseEnter={() => setHoveredService(service.id)}
              onMouseLeave={() => setHoveredService(null)}
            >
              <div className="service-overlay"></div>
              <div className="service-content">
                <div className="service-number">{service.number}</div>
                <div className="service-title">
                  <h3>{service.title}</h3>
                </div>
                <div className={`service-info ${hoveredService === service.id ? 'show' : ''}`}>
                  <p>{service.description}</p>
                  <div className="service-cta">
  <a href={service.link}>
    <span>Learn More</span>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"></line>
      <polyline points="12 5 19 12 12 19"></polyline>
    </svg>
  </a>
</div>

                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Navigation Dots */}
        <div className="slider-navigation">
          {services.map((_, index) => (
            <button
              key={index}
              className={`nav-dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            ></button>
          ))}
        </div>
        
        {/* Progress Bar */}
        <div className="slider-progress">
          <div 
            className="progress-bar" 
            style={{ width: `${((currentSlide + 1) / services.length) * 100}%` }}
          ></div>
        </div>
      </div>
    </section>
  );
}

export default Services;